import { zodResolver as hookformZodResolver } from "@hookform/resolvers/zod";
import { FieldValues, Resolver } from "react-hook-form";
import { z } from "zod";

/**
 * Zod 4-compatible wrapper around @hookform/resolvers.
 *
 * Official resolvers ≥5 map Zod 4 `issues` correctly at runtime, but Zod 4's
 * stricter input/output types conflict with our existing `useForm<T>(...)`
 * call sites. Cast to `Resolver<z.infer<T>>` until those forms are migrated
 * to inferred or three-generic `useForm` typing.
 */
export const zodResolver = <Schema extends z.ZodType>(schema: Schema): Resolver<z.infer<Schema> & FieldValues> =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (hookformZodResolver as (schema: Schema) => Resolver<any>)(schema) as Resolver<z.infer<Schema> & FieldValues>;
